import { useEffect, useState, useRef } from "react";
import { bindActionCreators } from "@reduxjs/toolkit";

import { useAppDispatch, useAppSelector } from "../../redux/store";
import { getClientBoards } from "../../redux/features/client-main/client-board-slice";
import { getAllClientIntakeStage } from "../../redux/features/client-main/client-intake-stage";
import { getProviderBoards } from "../../redux/features/providers-main/provider-board-slice";
import { getAllProviderOnBoardingStages } from "../../redux/features/providers-main/provider-onboardingstage-slice";
import {
  getAllAutomation,
  getAllCustomBoard,
} from "../../redux/features/custom-board/custom-board-slice";

import BoardSidePanel from "./BoardSidePanel";
import BoardPanel from "./BoardPanel";
import { Box } from "@mui/material";

const Board: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState({
    id: "Intake",
    type: "client",
  });
  const [drawerOpen, setDrawerOpen] = useState<boolean>(true);
  const selectedBoardTab = useAppSelector(
    (state) => state.boardSlice.selectedTab
  );
  const scrollPosition = useAppSelector(
    (state) => state.boardSlice.scrollPosition
  );
  const dispatch = useAppDispatch();
  const dispatchAction = bindActionCreators(
    {
      getClientBoards,
      getProviderBoards,
      getAllClientIntakeStage,
      getAllProviderOnBoardingStages,
      getAllCustomBoard,
      getAllAutomation,
    },
    dispatch
  );
  //ref for dispatchAction
  const dispatchActionRef = useRef(dispatchAction);

  useEffect(() => {
    dispatchActionRef.current.getAllClientIntakeStage();
    dispatchActionRef.current.getAllProviderOnBoardingStages();
    dispatchActionRef.current.getProviderBoards({ useLoader: false });
    dispatchActionRef.current.getClientBoards({ useLoader: false });
    dispatchActionRef.current.getAllAutomation();
    dispatchActionRef.current.getAllCustomBoard();
  }, []);

  useEffect(() => {
    if (selectedBoardTab) {
      setTimeout(() => {
        const [boardTemplate] =
          document.getElementsByClassName("boardTemplate");
        if (scrollPosition.length) {
          scrollPosition.forEach((item) => {
            if (item.boardId === selectedBoardTab.id) {
              boardTemplate.scrollLeft = item?.scrollLeft || 0;
              boardTemplate.scrollTop = item?.scrollTop || 0;
            }
          });
        }
      }, 30);
      setSelectedTab({ id: selectedBoardTab.id, type: selectedBoardTab.type });
    }
  }, [selectedBoardTab, scrollPosition]);

  //#endregion

  return (
    <div className="board">
      <Box className={drawerOpen ? "sideDrawer open" : "sideDrawer"}>
        <BoardSidePanel
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
        />
      </Box>

      {/* main board area */}
      <Box
        className="boardPanel"
        // sx={{ width: drawerOpen ? "calc(100% - 250px)" : "100%"}}
      >
        <BoardPanel
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
        />
      </Box>
      {/* Board Side Panel for Activity Center */}
    </div>
  );
};

export default Board;
